/**
 * Sort portal entity lists by id (Cand-2 before Cand-10, App-1 before App-9).
 */

export function compareEntityIds(idA, idB) {
  const a = String(idA ?? '');
  const b = String(idB ?? '');

  const parse = id => {
    const m = id.match(/^(.+?)-(\d+)$/i);
    if (m) {
      return { prefix: m[1].toLowerCase(), num: Number(m[2]), raw: id };
    }
    return { prefix: '', num: NaN, raw: id };
  };

  const pa = parse(a);
  const pb = parse(b);

  if (pa.prefix && pb.prefix && pa.prefix !== pb.prefix) {
    return pa.prefix.localeCompare(pb.prefix);
  }
  if (Number.isFinite(pa.num) && Number.isFinite(pb.num) && pa.num !== pb.num) {
    return pa.num - pb.num;
  }

  return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
}

export function sortByEntityId(items, idKey = 'id') {
  if (!items?.length) return items ? [...items] : [];
  return [...items].sort((x, y) => {
    const a = typeof idKey === 'function' ? idKey(x) : x?.[idKey];
    const b = typeof idKey === 'function' ? idKey(y) : y?.[idKey];
    return compareEntityIds(a, b);
  });
}

/** Newest / highest entity id first (Cand-32 before Cand-2). */
export function sortByEntityIdDesc(items, idKey = 'id') {
  if (!items?.length) return items ? [...items] : [];
  return [...items].sort((x, y) => {
    const a = typeof idKey === 'function' ? idKey(x) : x?.[idKey];
    const b = typeof idKey === 'function' ? idKey(y) : y?.[idKey];
    return compareEntityIds(b, a);
  });
}

export const DEFAULT_LIST_SORT = { key: 'id', dir: 'desc' };
